import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import classNames from 'classnames';

import { getIn } from 'src/utils/ChangeSpy';
import { exportStats } from 'src/actions/statistics';
import TopPanel from './TopPanel';
import BottomPanel from './BottomPanel';
import ChartsPanel from './ChartsPanel';
import { Spinner } from '../helpers/Spinner';
import { AppPage } from '../AppPage';
import Button from '../helpers/Button';

import style from './style.module.css';

const Dashboard = ({ data, onChangeYear }) => {
  const selectYearRef = useRef();
  const isFetching =
    getIn(data, ['years', 'isFetching']) ||
    getIn(data, ['allTransactions', 'isFetching']) ||
    getIn(data, ['addOnTransactions', 'isFetching']) ||
    getIn(data, ['platformTransactions', 'isFetching']) ||
    getIn(data, ['buyers', 'isFetching']) ||
    getIn(data, ['dealsClosed', 'isFetching']) ||
    getIn(data, ['dealsClosedByState', 'isFetching']) ||
    getIn(data, ['targetsStats', 'isFetching']) ||
    getIn(data, ['buyersStats', 'isFetching']) ||
    getIn(data, ['executivesStats', 'isFetching']) ||
    getIn(data, ['dealsClosedByYears', 'isFetching']) ||
    getIn(data, ['executiveDeals', 'isFetching']) ||
    getIn(data, ['professionals', 'isFetching']) ||
    getIn(data, ['targetsApproachedByYears', 'isFetching']);
  const spinner = isFetching ? <Spinner className="bg-white" /> : null;

  const handleChangeYear = event => {
    onChangeYear(event.target.value);
  };

  const handleExport = () => {
    exportStats(selectYearRef.current.value);
  };

  const years = getIn(data, ['years', 'years']);

  const toolbar = (
    <>
      <label className={style.yearLabel} htmlFor="dashboardYear">
        Statistics for
      </label>
      <select
        ref={selectYearRef}
        className={classNames(style.year, 'form-control')}
        id="dashboardYear"
        name="year"
        onChange={handleChangeYear}
      >
        <option key="defaultYear" value="">
          All
        </option>
        {years.map(year => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </select>
      <div className={style.toolbar}>
        <Button onClick={handleExport}>
          <i aria-hidden="true" className="fa fa-download" /> Export
        </Button>
      </div>
    </>
  );

  return (
    <AppPage overline="Statistics" title="Dashboard" toolbar={toolbar}>
      <div className={style.host}>
        <div className={style.column}>
          <TopPanel data={data} />
          <BottomPanel data={data} />
        </div>
        <div className={style.column}>
          <ChartsPanel data={data} />
        </div>
        {spinner}
      </div>
    </AppPage>
  );
};

Dashboard.propTypes = {
  data: PropTypes.instanceOf(Map).isRequired,
};

export default Dashboard;
